import { message } from 'antd';
import { useTranslation } from 'react-i18next';

interface SetAlertProps {
  alert: string;
  destroy?: boolean;
  type?: 'info' | 'loading' | 'success' | 'warning';
}

export function useAlert() {
  const [messageApi, context] = message.useMessage();
  const { t } = useTranslation();

  return {
    alert: context,
    setAlert: ({ alert, destroy = false, type = 'info' }: SetAlertProps) => {
      if (destroy) messageApi.destroy();

      if (type === 'loading') {
        return messageApi.open({
          type,
          content: t(`alert.${alert}`),
          duration: 0
        });
      }

      return messageApi[type](t(`alert.${alert}`));
    }
  };
}
